// THE WHOLE-QUOTE PRICING OVERLAY'S PROGRESS, AS A WHOLE PERCENTAGE.
//
// The progress is real but coarse: sections finished pricing / total priceable. A section is counted done only
// once its whole pricing cascade drains (see FrankQuoteBuilderPage's settle effects), so the single milestone a
// ONE-section quote has -- by far the common case -- does not land until the very end. That left the bar frozen
// at a literal 0% for the entire wait, which reads as "nothing is happening" when the truth is "pricing".
//
// So the bar starts at a small non-zero floor the instant the overlay appears: an honest "we have started"
// signal, not a faked curve toward a ceiling. The floor only ever RAISES a reading below it -- it is a max, not a
// replace, so the bar never jumps backwards as the first real sections land -- and a finished quote still reads
// 100%.
export const PRICING_START_FLOOR_PERCENT = 10;

export const pricingSettlePercent = (settledSectionCount, totalPriceableSections) => {
  if (totalPriceableSections <= 0) { return 100; }

  const realPercent = Math.round(
    Math.min(1, settledSectionCount / totalPriceableSections) * 100
  );
  return Math.max(PRICING_START_FLOOR_PERCENT, realPercent);
};
